import React from "react";
import { Row, Col, Typography, Button } from "antd";
import { ExclamationCircleTwoTone } from "@ant-design/icons";

const { Title, Paragraph } = Typography;

const Error = (props) => {
  return (
    <>
      <Row className='mb-5' justify='center' align='top' gutter={[16, 0]}>
        <Col>
          <ExclamationCircleTwoTone className='mt-2' style={{ fontSize: "32px" }} twoToneColor='#ff1010' />
        </Col>
        <Col>
          <Title>Detection Error</Title>
        </Col>
      </Row>
      <Row>
        <Col style={{ fontSize: "1.2em" }}>{props.children}</Col>
      </Row>
      <Row className='mt-5' justify='center' gutter={[16, 16]}>
        <Col>
          <Button size='large' type='default' onClick={props.onContinue}>
            Go Back
          </Button>
        </Col>
        <Col>
          <Button size='large' type='primary' onClick={props.onRetry}>
            Retry Detection
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default Error;
